import React, { useState, useEffect, useRef } from 'react';

const CooldownTimer = ({ targetTime, onComplete }) => {
  const [timeRemaining, setTimeRemaining] = useState('');
  
  const timerRef = useRef(null);
  
  useEffect(() => {
    // Function to calculate and update remaining time
    const updateRemainingTime = () => {
      const now = new Date();
      const targetDate = new Date(targetTime);
      const timeDiff = targetDate - now;
      
      if (timeDiff <= 0) {
        // Timer complete
        clearInterval(timerRef.current);
        setTimeRemaining('Complete');
        // Call the onComplete prop instead of using setIsComplete
        if (onComplete) {
          onComplete();
        }
        return;
      }
      
      // Format the time remaining
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
      
      setTimeRemaining(
        `${hours > 0 ? hours + 'h ' : ''}${minutes}m ${seconds}s`
      );
    };
    
    // Initial call to set time
    updateRemainingTime();
    
    // Set up the interval
    timerRef.current = setInterval(updateRemainingTime, 1000);
    
    // Cleanup on unmount
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [targetTime, onComplete]);
  
  return <span className="countdown-timer">{timeRemaining}</span>;
};

export default CooldownTimer;